import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import { useNavigate } from 'react-router-dom';

const OrderFlowSpotBuy = () => {
  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const [annotations, setAnnotations] = useState([]);
  const [videoTitle, setVideoTitle] = useState('Think5Whys'); 
  const [videoId, setVideoId] = useState('video123');
  const [serialNumber, setSerialNumber] = useState(1); 
  const [hitCounter, setHitCounter] = useState(0); 
  const [showHitCounter, setShowHitCounter] = useState(false);

  

  const fetchAnnotations = useCallback(() => {
    const config = { 
      url: "/annotations/getforvideoid", 
      method: "post", 
      headers: { Authorization: authState.token }, 
      data: { videoId: videoId }
    };
    // console.log("config :", config);

    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("Response annotations :", response.annotations);
        // console.log("Response annotations :", response.annotations.videoTitle);

        setAnnotations(response.annotations);
        setVideoTitle(response.annotations.videoTitle);
      })
      .catch(error => {
        console.error("Error fetching annotations:", error);
      });
  }, [authState.token, fetchData, videoTitle]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchAnnotations();
  }, [authState.isLoggedIn, fetchAnnotations]);


  useEffect(() => {
    const interval = setInterval(() => {
      setSerialNumber(prev => prev + 1); 
    }, 15000);

    return () => clearInterval(interval); 
  }, []);

  const handleCoinClick = () => {
    setHitCounter(prev => prev + 1); 
    setShowHitCounter(prev => !prev); 
  };

  return (
    <div className="order-flow-spot-buy">
      <VideoWithAnnotations annotations={annotations} videoTitle={videoTitle} />
      {/* <GoldCoinDisplay serialNumber={serialNumber} /> */}
      <GoldCoinDisplay 
        serialNumber={serialNumber} 
        hitCounter={hitCounter}
        showHitCounter={showHitCounter}
        onCoinClick={handleCoinClick} 
      />
    </div>
  );
};

const GoldCoinDisplay = ({ serialNumber, hitCounter, showHitCounter, onCoinClick }) => {
  return (
    <div 
      style={{ position: 'fixed', bottom: '10px', right: '10px', fontSize: '50px', cursor: 'pointer' }} 
      onClick={onCoinClick} 
    >
      {showHitCounter && (
        <div style={{ position: 'absolute', left: '-70px', bottom: '10px', fontSize: '24px', color: 'yellow' }}>
          Hits: {hitCounter}
        </div>
      )}
      <span role="img" aria-label="gold coin">💰</span>
      <span className='text-yellow-200'>{serialNumber}</span>
    </div>
  );
};

const VideoWithAnnotations = ({ annotations, videoTitle }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [showPoweredBy, setShowPoweredBy] = useState(true);
  const [annotationMarkers, setAnnotationMarkers] = useState([]);
  const navigate = useNavigate();

  const resizeCanvas = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;

    if (!video || !canvas) return;

    canvas.width = video.clientWidth;
    canvas.height = video.clientHeight;
  };

  const drawAnnotations = () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    const video = videoRef.current;

    if (!video || !canvas) return;

    resizeCanvas();
    context.clearRect(0, 0, canvas.width, canvas.height);

    context.font = '14px Arial';
    context.fillStyle = 'yellow';
    context.textAlign = 'right';
    context.fillText(videoTitle, canvas.width - 20, 40);

    const markers = [];
    if (annotations.annotations && annotations.annotations.length > 0) {
      annotations.annotations.forEach(annotation => {
        const { coordinates, description, timestamp } = annotation;

        if (Math.abs(currentTime - timestamp) < 1.5) {
          const x = coordinates.x * (canvas.width / video.videoWidth);
          const y = coordinates.y * (canvas.height / video.videoHeight);

          context.beginPath();
          context.arc(x, y, 10, 0, 2 * Math.PI);
          context.fillStyle = 'rgba(255, 0, 0, 0.5)';
          context.fill();
          context.stroke();

          context.font = '16px Arial';
          context.fillStyle = '#fff';
          context.fillText(description, x + 15, y - 15);

          markers.push({ x, y, radius: 10, annotation });
        }
      });
    }

    setAnnotationMarkers(markers);

    if (showPoweredBy || (annotations.annotations && annotations.annotations.some(annotation => Math.abs(currentTime - annotation.timestamp) < 1.5))) {
      context.font = '12px Arial';
      context.fillStyle = 'yellow';
      context.textAlign = 'left';
      context.fillText("Annotations Powered By Think5Whys", 20, 40);
    }
  };

  const handleTimeUpdate = () => {
    setCurrentTime(videoRef.current.currentTime);
    drawAnnotations();
  };

  const handleClick = (event) => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const rect = canvas.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    // console.log("Canvas click coordinates:", x, y);
    // console.log("Markers:", annotationMarkers);

    for (const marker of annotationMarkers) {
      const distance = Math.sqrt((x - marker.x) ** 2 + (y - marker.y) ** 2);
      if (distance < marker.radius) {
        // console.log("Marker clicked, navigating to /orderflow-products");
        videoRef.current.pause();
        navigate("/orderflow-products");
        return;
      }
    }
  };

  useEffect(() => {
    const videoElement = videoRef.current;
    const canvasElement = canvasRef.current;

    if (videoElement && canvasElement) {
      videoElement.addEventListener('timeupdate', handleTimeUpdate);
      videoElement.addEventListener('loadedmetadata', drawAnnotations);
      window.addEventListener('resize', drawAnnotations);
      canvasElement.addEventListener('click', handleClick);

      const poweredByTimeout = setTimeout(() => {
        setShowPoweredBy(false);
      }, 3000);

      return () => {
        videoElement.removeEventListener('timeupdate', handleTimeUpdate);
        videoElement.removeEventListener('loadedmetadata', drawAnnotations);
        window.removeEventListener('resize', drawAnnotations);
        canvasElement.removeEventListener('click', handleClick);
        clearTimeout(poweredByTimeout);
      };
    }
  }, [annotations, currentTime, videoTitle, annotationMarkers]);

  return (
    <div className="video-container" style={{ position: 'relative', width: '100%' }}>
      <video
        ref={videoRef}
        controls
        width="100%"
        src={`/api/downloads/markupvideos/${annotations.videoFileName}.mp4`}
        style={{ display: 'block' }}
      />
      <canvas
        ref={canvasRef}
        className="annotation-canvas"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          pointerEvents: 'none',
          zIndex: 1000,
        }}
      />
    </div>
  );
};

export default OrderFlowSpotBuy;
